import React from 'react';
import { useNavigate } from 'react-router-dom';
import './VisitorSelection.css';
import receptionBg from '../assets/images/backgrounds/reception-bg.png';

const VisitorSelection = () => {
    const navigate = useNavigate();

    const visitorTypes = [
        {
            id: 'general',
            title: 'General Visitor',
            icon: '👤',
            description: 'Standard visitor registration',
            color: '#3b82f6'
        },
        {
            id: 'delivery',
            title: 'Delivery',
            icon: '📦',
            description: 'Package or courier delivery',
            color: '#10b981'
        },
        {
            id: 'interview',
            title: 'Interview',
            icon: '💼',
            description: 'Job candidate interview',
            color: '#8b5cf6'
        },
        {
            id: 'meeting',
            title: 'Meeting',
            icon: '🤝',
            description: 'Scheduled appointment',
            color: '#f59e0b'
        },
        {
            id: 'contractor',
            title: 'Contractor',
            icon: '🔧',
            description: 'Service provider or vendor',
            color: '#06b6d4'
        }
    ];

    const handleVisitorTypeSelect = (typeId) => {
        navigate(`/visitor/form/${typeId}`);
    };

    return (
        <div className="visitor-selection-container" style={{ backgroundImage: `url(${receptionBg})` }}>
            <div className="visitor-selection-content">
                <div className="visitor-selection-header">
                    <img src="/logo.png" alt="Logo" className="app-logo" />
                    <div>
                        <h1>Welcome to Our Reception</h1>
                        <p>Please select your visit type to register</p>
                    </div>
                </div>

                <div className="visitor-selection-grid">
                    {visitorTypes.map((type, index) => (
                        <div
                            key={type.id}
                            className="visitor-selection-card card fade-in"
                            style={{
                                animationDelay: `${index * 0.1}s`,
                                '--card-color': type.color
                            }}
                            onClick={() => handleVisitorTypeSelect(type.id)}
                        >
                            <h3>{type.title}</h3>
                            <p>{type.description}</p>
                            <div className="visitor-selection-arrow">→</div>
                        </div>
                    ))}
                </div>

                <div className="visitor-selection-footer">
                    <p>Your information will be kept confidential and used only for visitor management purposes.</p>
                </div>
            </div>
        </div>
    );
};

export default VisitorSelection;
